import apiClient from "services/apiClient";

async function addMarkerStyle(data: any) {
  const url = `/admin/marker-style`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addMarkerStyle;
